import { DeleteOutline, DownloadOutlined } from "@mui/icons-material";
import { CircularProgress, IconButton, useTheme } from "@mui/material";
import { toast } from "sonner";

import { getFilesFileIDDownloadUrl } from "Infrastructure/Api/Api";
import { isSuccessResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

interface DocumentRowProps {
  documentID: string;
  fileName: string;
  fileID: string;
  onDelete?: (documentID: string) => void;
  isDeleting?: boolean;
}

export const DocumentRow = ({
  documentID,
  fileName,
  fileID,
  onDelete,
  isDeleting,
}: DocumentRowProps): React.ReactNode => {
  const { t } = useResource();
  const theme = useTheme();

  const handleDownload = async () => {
    try {
      const response = await getFilesFileIDDownloadUrl(fileID);
      if (isSuccessResponse(response)) {
        const fileResponse = await fetch(response.data.downloadUrl);
        const blob = await fileResponse.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = response.data.fileName ?? fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else {
        toast.error(t(Resources.Documents.DownloadError));
      }
    } catch {
      toast.error(t(Resources.Documents.DownloadError));
    }
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleDownload}
        title={fileName}
        color="primary"
      >
        <DownloadOutlined fontSize="small" />
      </IconButton>
      {onDelete && (
        <IconButton
          size="small"
          onClick={() => onDelete(documentID)}
          disabled={isDeleting}
          sx={{ color: theme.palette.error.main }}
        >
          {isDeleting ? (
            <CircularProgress size={16} />
          ) : (
            <DeleteOutline fontSize="small" />
          )}
        </IconButton>
      )}
    </>
  );
};
